import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import { DesktopTopBar, DesktopTopBarProps } from "./Desktop";
import { MobileTopBar, MobileTopBarProps } from "./Mobile";

interface Props extends DesktopTopBarProps, MobileTopBarProps {}

export function TopBar({ search, sidebar, menu, logo }: Props) {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  return isDesktop ? (
    <DesktopTopBar search={search} menu={menu} />
  ) : (
    <MobileTopBar search={search} sidebar={sidebar} logo={logo} />
  );
}
